import React, { FC } from 'react';
import { FormSelect } from '../../../../../components/common/form_select';

type SelectInputFieldConfig = {
    inputName: string;
    options: { label: string; value: any }[];
    selectedValue: any;
};

interface IProps {
    data: Record<string, SelectInputFieldConfig>;
}

const ExtrasFields: FC<IProps> = ({ data }) => {
    return (
        <div className="grid gap-6 lg:gap-8 2xl:gap-10 px-3 sm:px-4 2xl:px-5">
            {Object.entries(data).map(([subkey, subvalue], index: number) => {
                return (
                    <div key={index}>
                        <FormSelect
                            maxWidth='350px'
                            isClearable={true}
                            label={subkey}
                            options={subvalue.options}
                            name={subvalue.inputName}
                            layout="horizontal"
                        />
                    </div>
                );
            })}
        </div>
    );
};

export { ExtrasFields, type SelectInputFieldConfig };